import { Button } from "@mui/material";
import { ArrowRightIcon } from "Components/_Shared/Icons/Icons";
import { useCloneAnalysis } from "Infrastructure/ApiZfp/AnalyzerApi";
import { ClientAnalysisReferenceState } from "Infrastructure/ApiZfp/Schema";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { useNavigate } from "react-router-dom";

type Props = {
  readonly analysisState: ClientAnalysisReferenceState;
  readonly analysisId: string;
  readonly versionId: string;
  readonly isDisabled?: boolean;
};

export const ContinueExistingAnalysisButton: React.FC<Props> = ({ analysisId, versionId, analysisState, isDisabled = false }) => {
  const { t } = useResource();
  const navigate = useNavigate();
  const { mutate: createNewAnalysisVersion, isPending } = useCloneAnalysis({
    mutation: {
      onSuccess: (result) => {
        navigate(AppRouting.AnalysisDetail.path(result.analysisId, result.versionId));
      },
    },
  });

  return (
    <Button
      variant="text"
      color="primary"
      endIcon={<ArrowRightIcon />}
      loading={isPending}
      disabled={isDisabled}
      onClick={() => {
        if (analysisState === ClientAnalysisReferenceState.in_progress) {
          navigate(AppRouting.AnalysisDetail.path(analysisId, versionId));
        }

        const statesRequiringNewVersion: ClientAnalysisReferenceState[] = [
          ClientAnalysisReferenceState.completed,
          ClientAnalysisReferenceState.declined,
        ];

        if (statesRequiringNewVersion.includes(analysisState)) {
          createNewAnalysisVersion({
            analysisId,
            versionId,
          });
        }
      }}
    >
      {t(Resources.NewAnalysis.Form.Button.Continue)}
    </Button>
  );
};
